// extracted by mini-css-extract-plugin
module.exports = {"packageContainer":"InsurancePackage_packageContainer__db4kl"};